/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react'
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import classes from './profileInfo.module.scss';
import { useAuth0 } from '@auth0/auth0-react';
import { AddFreiendSvg, BagSvg, CrossBorderSvg, LeftArrowSvg, MiniSucessSvg, RefSvg, SmallDownSvg, SmallUpSvg } from "../../../constants/resources";
import showMessage from '../Common/notification';
import ComponentMap from '../../../atom/componentMap';
import { getENVData, isDev } from '../../../constants/constantValue';
import shortid from 'shortid';
import { QueryUserProfileResult, UserProfile } from '../../../atom/Types';
import refferal from '../../../asset/reward-desktop.png'
import mobRefferal from '../../../asset/reward-mobile.png'
import { SEND_EMAIL } from '../../../graphQL/mutations';
import ReferralEmailTemplate from '../../../atom/ReferralEmailTemplate';
import moment from 'moment';
import TC from './terms-conditions';
import hash from 'object-hash';

interface Bonus {
    amount: number;
    createdOn: string;
    id: string;
    status: string;
    type: string;

}

export const QUERY_USERPROFILE = gql`query MyQuery($email: String) {
    queryUserProfile(filter: {email: {allofterms: $email}}) {
        id
        firstName
        lastName
        phone
        email
        refCode
        referred
        {
        firstName
        lastName
        }
        bonus
        {
            id
            amount
            createdOn
            status
            type
            approvedBy
            {
                firstName
                lastName
                email
            }
        }
    }
}`;

export const UPDATE_USERPROFILE = gql`mutation MyMutation($email: String, $refCode: String) {
    updateUserProfile(input: {filter: {email: {allofterms: $email}}, set: {refCode: $refCode}}) {
      numUids
    }
}`;

const Referrals = (props: any) => {
    const { setProfile } = props;
    const { user } = useAuth0();
    const [send, setSend] = useState(0);
    const [userProfile, setUserProfile] = useState<any>();
    const [link, setLink] = useState('');
    const inputRef = useRef<any>(null);
    const [dataReady, setDataReady] = useState<{ data: Bonus[], display: Boolean, bonus: number, referred: string | null }>({ data: [], display: true, bonus: 0, referred: null })
    const [pendingBonus, setPendingBonus] = useState<{ data: Bonus[], display: Boolean, bonus: number, referred: string | null }>({ data: [], display: false, bonus: 0, referred: null })
    const [usedBonus, setUsedBonus] = useState<{ data: Bonus[], display: Boolean, bonus: number, referred: string | null }>({ data: [], display: false, bonus: 0, referred: null })
    const [showTc, setShowTc] = useState(false)
    const [showAll, setShowAll] = useState('')
    const [loader, setLoader] = useState(true)
    const [loading, setLoading] = useState(false);

    const [queryUserProfile, { refetch: UserProfileRefetch }] = useLazyQuery<QueryUserProfileResult>(QUERY_USERPROFILE);
    const [updateUserProfile] = useMutation(UPDATE_USERPROFILE);

    useEffect(() => {
        if (user === null) {
            return;
        }

        // debugger;

        queryUserProfile({ variables: { email: user!.email } }).then((up: any) => {
            if (up.data && up.data.queryUserProfile && up.data.queryUserProfile.length > 0) {
                setUserProfile(up.data.queryUserProfile[0]);
            }
            else {
                console.error('queryexecutionfailex')
            }
        }).catch((ex) => {
            throw ex;
        })
    }, [user?.email]);

    // console.log(userProfile, 'userProfile');

    useEffect(() => {
        setLoader(true)

        if (userProfile) {
            setLoader(false)
            GenerateLink()

            let Ready: Bonus[] = []
            let ReadyBonus: number = 0
            let Pending: Bonus[] = []
            let PendingBonus: number = 0
            let Used: Bonus[] = []
            let UsedBonus: number = 0
            console.log(userProfile, 'userProfile');

            if (userProfile && Object.keys(userProfile).length > 0) {
                Ready = userProfile?.bonus?.filter((item: any) => { return item.status === 'READY' })
                if (Ready?.length > 0) {
                    ReadyBonus = Ready?.reduce((sum: number, item) => sum + item.amount, 0);
                    setDataReady({ data: Ready, display: true, bonus: ReadyBonus, referred: userProfile?.referred?.firstName })
                }
                Pending = userProfile?.bonus?.filter((item: any) => { return item.status === 'PENDING' })
                if (Pending?.length > 0) {
                    PendingBonus = Pending?.reduce((sum: number, item) => sum + item.amount, 0);
                    setPendingBonus({ data: Pending, display: Ready.length === 0 ? true : false, bonus: PendingBonus, referred: userProfile?.referred?.firstName })
                }
                Used = userProfile?.bonus?.filter((item: any) => { return item.status === 'USED' })
                if (Used?.length > 0) {
                    UsedBonus = Used?.reduce((sum: number, item) => sum + item.amount, 0);
                    setUsedBonus({ data: Used, display: Ready.length === 0 && pending.length === 0 ? true : false, bonus: UsedBonus, referred: userProfile?.referred?.firstName })
                }

            }
        }

    }, [userProfile])

    const [Email] = useMutation(SEND_EMAIL, {
        onError: (error) => {

        }
    })

    const works = [
        { image: <AddFreiendSvg />, title: 'Refer a friend to Travelsment', desc: 'Refer your friends to Travelsment by sharing the referral link.' },
        { image: <BagSvg />, title: 'They get $200 off their first booking', desc: 'New clients you refer to us will receive $200 credit toward their first trip.' },
        { image: <RefSvg />, title: 'You get $200 off a future booking', desc: 'You will earn a $200 credit toward future travel once your friend completes their trip.' }
    ]

    const [dataFields, setDataFields] = useState<any>([{
        name: 'firstName',
        title: 'First Name',
        value: '',
        placeholder: 'Enter first name',
        required: false,
        error: false,
        errormessage: 'Enter first name'
    }, {
        name: 'lastName',
        title: 'Last name',
        value: '',
        placeholder: 'Enter last name',
        required: false,
        error: false,
        errormessage: 'Enter last Name'
    }, {
        name: 'email',
        title: 'Email*',
        type: 'email',
        value: '',
        placeholder: 'Enter email',
        required: true,
        error: false,
        errormessage: 'Enter email',
    }]);

    const SendEmail = () => {
        setLoading(true)
        const email = dataFields.find((f: any) => f.name === 'email');

        if (email.value === '') {
            const newFields = [...dataFields];

            newFields.find((f: any) => f.name === 'email').error = true;
            setDataFields(newFields);
            showMessage("Validation error", "Email is required", "danger");

            return;
        }
        const emailContent = ReferralEmailTemplate(dataFields, link)
        if (emailContent) {
            Email({
                variables: {
                    to: dataFields[2].value.toString(),
                    subject: `Refferal Link`,
                    body: emailContent,
                    submitTime: Date.now()
                }
            }).then((response) => {
                if (response.errors === undefined) {
                    setLoading(false)
                    setSend(2);

                } else {
                    setLoading(false)
                    alert('error')
                }
            })
        }
    }

    const createHashCode = async function () {
        if (!userProfile?.refCode) {

            //const refCode = shortid.generate();

            const h = hash({ email: user!.email }, { algorithm: 'md5', encoding: 'base64' });
            const refCode = h.substring(0, h.length - 2);

            try {
                await updateUserProfile({
                    variables: {
                        email: user!.email,
                        refCode: refCode
                    }
                });

                const up = await UserProfileRefetch({
                    variables: {
                        email: user!.email
                    }
                });

                if (up.data && up.data.queryUserProfile && up.data.queryUserProfile.length > 0) {
                    setUserProfile(up.data.queryUserProfile[0]);
                }
                else {
                    console.error('queryexecutionfailex')
                }
            }
            catch (ex: any) {
            }

            return refCode;
        }

        return userProfile?.refCode;
    }

    const GenerateLink = async () => {
        const code = await createHashCode();
        //setLink(`${getENVData().url}/?ref=${code}`);
        //var url = `https://travelsment.com/referral?refCode=${encodeURIComponent(code)}`;
        var url = `https://travelsment.com/referral?refCode=${code}`;

        if (isDev()) {
            url += "&dev=1";
        }
        
        setLink(url);
    }

    const Copy = async () => {
        try {
            if (document.activeElement !== inputRef.current) {
                inputRef.current.focus();
            }
            console.log(link, 'lamoraaa');
            await navigator.clipboard.writeText(link);
            console.log(link, 'lamoraaa');

            showMessage("Link copied success", "Link copied to clipboard", "success");
        }
        catch (ex) {
            showMessage("Failed to copy Link", "PLease copy the link manually", "warning");
        }
    }

    const handleClose = () => {
        setSend(0)
        setDataFields([{
            name: 'firstName',
            title: 'First Name',
            value: '',
            placeholder: 'Enter first name',
            required: false,
            error: false,
            errormessage: 'Enter first name'
        }, {
            name: 'lastName',
            title: 'Last name',
            value: '',
            placeholder: 'Enter last name',
            required: false,
            error: false,
            errormessage: 'Enter last Name'
        }, {
            name: 'email',
            title: 'Email*',
            type: 'email',
            value: '',
            placeholder: 'Enter email',
            required: true,
            error: false,
            errormessage: 'Enter email',
        }])
    }

    console.log(userProfile?.referred?.firstName, 'dataFields');


    return (
        !loader ? <>
            <div className={classes.flex} onClick={() => setProfile('Main')} >
                <LeftArrowSvg />
                <div className={classes.backButton}>Back</div>
            </div>
            <div className={classes.refferalMain}>
                <div className={classes.imgSection}>
                    <img src={refferal} alt='reff' />
                    <div className={classes.imgContent}>
                        <p>your current Balance</p>
                        <p style={{ fontWeight: '700', fontSize: '64px' }}>${dataReady.bonus}</p>
                    </div>
                </div>
                <div className={classes.mobImgSection}>
                    <img src={mobRefferal} alt='reff' />
                    <div className={classes.imgContent}>
                        <p>your current Balance</p>
                        <p style={{ fontWeight: '700', fontSize: '64px' }}>${dataReady.bonus}</p>
                    </div>
                </div>
                {dataReady.data.length > 0 ? <div className={classes.readyMain}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <p className={classes.readyHead}>
                            Ready to use Bonuses
                        </p>
                        <p className={classes.readyRight} onClick={() => setPendingBonus({ ...pendingBonus, display: !pendingBonus.display })}>
                            ${dataReady.bonus} <SmallDownSvg width={20} height={20} />
                        </p>
                    </div>
                    {dataReady.display ? <> <table className={classes.customTable}>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Referral name</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataReady.data.filter((_, index) => { return index < 3 }).map((item, index: number) => (
                                <tr key={index}>
                                    <td>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</td>
                                    <td>{item.type}</td>
                                    <td>{item.amount}</td>
                                    <td>{dataReady?.referred}</td>
                                    <td>
                                        <span className={classes.statusBadge1}>Ready to use</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                        {dataReady.data.map((item, index: number) => {
                            return <div key={index} className={classes.displayBox}>
                                <p className={classes.content}>Date</p>
                                <p className={classes.content}>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</p>
                                <p className={classes.content}>Type</p>
                                <p className={classes.desc}>{item.type}</p>
                                <p className={classes.content}>Amount</p>
                                <p className={classes.desc}>${item.amount}</p>
                                <p className={classes.content}>Referral name</p>
                                <p className={classes.content}>{userProfile?.referred?.firstName}</p>
                                <p className={classes.content}>Status</p>
                                <button className={classes.statusBadge1}>Ready to use</button>
                            </div>
                        })}
                        {dataReady.data.length > 3 && <button onClick={() => setShowAll('ready')} className={classes.tableButton}>Show all ready to use</button>}
                    </> : null}

                </div> : null}
                {pendingBonus.data.length > 0 ? <div className={classes.readyMain}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <p className={classes.readyHead}>
                            Pending Bonuses
                        </p>
                        <p className={classes.readyRight} onClick={() => setPendingBonus({ ...pendingBonus, display: !pendingBonus.display })}>
                            ${pendingBonus.bonus} <SmallDownSvg width={20} height={20} />
                        </p>
                    </div>
                    {pendingBonus.display ? <><table className={classes.customTable}>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Referral name</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendingBonus.data.filter((_, index) => { return index < 5 }).map((item, index) => (
                                <tr key={index}>
                                    <td>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</td>
                                    <td>{item.type}</td>
                                    <td>{item.amount}</td>
                                    <td>{pendingBonus.referred}</td>
                                    <td>
                                        <span className={classes.statusBadge2}>Pending</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                        {pendingBonus.data.map((item, index) => {
                            return <div key={index} className={classes.displayBox}>
                                <p className={classes.content}>Date</p>
                                <p className={classes.content}>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</p>
                                <p className={classes.content}>Type</p>
                                <p className={classes.desc}>{item.type}</p>
                                <p className={classes.content}>Amount</p>
                                <p className={classes.desc}>${item.amount}</p>
                                <p className={classes.content}>Referral name</p>
                                {pendingBonus.referred && <p className={classes.content}>{pendingBonus.referred}</p>}
                                <p className={classes.content}>Status</p>
                                <button className={classes.statusBadge2}>Pending</button>
                            </div>
                        })}
                        {pendingBonus.data.length > 5 && <button onClick={() => setShowAll('pending')} className={classes.tableButton}>Show all pending</button>}
                    </>
                        : null}
                </div> : null}
                {usedBonus.data.length > 0 ? <div className={classes.readyMain}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <p className={classes.readyHead}>
                            Used Bonuses
                        </p>
                        <p className={classes.readyRight} onClick={() => setUsedBonus({ ...usedBonus, display: !usedBonus.display })}>
                            ${usedBonus.bonus} <SmallDownSvg width={20} height={20} />
                        </p>
                    </div>
                    {usedBonus.display ? <> <table className={classes.customTable}>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Referral name</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usedBonus.data.filter((_, index) => { return index < 5 }).map((item, index) => (
                                <tr key={index}>
                                    <td>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</td>
                                    <td>{item.type}</td>
                                    <td>{item.amount}</td>
                                    <td>{usedBonus.referred}</td>
                                    <td>
                                        <span className={classes.statusBadge3}>Used</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                        {usedBonus.data.map((item, index) => {
                            return <div key={index} className={classes.displayBox}>
                                <p className={classes.content}>Date</p>
                                <p className={classes.content}>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</p>
                                <p className={classes.content}>Type</p>
                                <p className={classes.desc}>{item.type}</p>
                                <p className={classes.content}>Amount</p>
                                <p className={classes.desc}>${item.amount}</p>
                                <p className={classes.content}>Referral name</p>
                                <p className={classes.content}>{usedBonus.referred}</p>
                                <p className={classes.content}>Status</p>
                                <button className={classes.statusBadge3}>Used</button>
                            </div>
                        })}
                        {usedBonus.data.length > 5 && <button onClick={() => setShowAll('used')} className={classes.tableButton}>Show all used</button>}
                    </> : null}
                </div> : null}
                <div className={classes.refferalModal}>
                    <div className={classes.refferalDetails}>
                        <p className={classes.referHead}>Refer a friend and earn rewards</p>
                        <p className={classes.referdesc}>Refer a friend to Travesment and receive $200</p>
                        <div className={classes.copyRef}>
                            <p className={classes.referHead} style={{ fontSize: '16px' }}>Copy referral link</p>
                            <div className={classes.copyContent}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <p>{link}</p>
                                    <span style={{ cursor: 'pointer' }} ref={inputRef} onClick={() => Copy()}>Copy Link</span>
                                </div>
                                <button onClick={() => setSend(1)}>
                                    share via Email
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <div className={classes.workModal}>
                    <p>
                        How it Works?
                    </p>
                    <div className={classes.workDetails}>
                        {works.map((data, index) => {
                            return <div key={index} className={classes.workDesc}>
                                <span>{data.image}</span>
                                <p>{data.title}</p>
                                <p className={classes.descStyle}>{data.desc}</p>
                            </div>
                        })}
                    </div>
                </div>
                {showTc ? <TC /> : null
                }
                <div className={classes.tcButton} onClick={() => setShowTc(!showTc)}>
                    {showTc ? <button>
                        <SmallUpSvg width={9} height={8} />Hide terms & conditions
                    </button> : <button>
                        <SmallDownSvg width={9} height={8} />Show terms & conditions
                    </button>}
                </div>
                <div>

                </div>
            </div>

            {send === 1 && <div className={classes.ModalBackground}>
                <div className={classes.ModalContent}>
                    <div style={{ padding: '16px' }}>
                        <div className={classes.refHead}>
                            <p className={classes.readyHead} style={{ fontSize: '20px' }}>Send email invite</p>
                            <span style={{ cursor: 'pointer' }} onClick={() => setSend(0)}><CrossBorderSvg /></span>
                        </div>
                        {dataFields.filter((node: any) => {
                            return !node.hidden;
                        }).map((node: any, key: any) => (
                            <div key={key}>
                                <ComponentMap node={node} data={dataFields} change={setDataFields} />
                            </div>
                        ))}
                        <div className={classes.refHead} style={{ marginTop: '20px' }}>
                            <button className={classes.buttonRef} onClick={SendEmail} disabled={loading}>
                                <span>Send Email</span>
                                {loading && <div className={classes.loaderButton}></div>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>}

            {
                send === 2 && <div className={classes.ModalBackground}>

                    <div className={classes.ModalContent1}>

                        <MiniSucessSvg />
                        <p className={classes.readyHead} style={{ fontSize: '20px' }}>Congratulations</p>
                        <div>
                            <p className={classes.paraDesc}>We have sucessfully sent the refferal link to</p>
                            <p className={classes.paraDesc}>email: {dataFields[2]?.value}</p>
                        </div>
                        <button onClick={() => handleClose()}>Close</button>

                    </div>
                </div>
            }
            {showAll === 'ready' ? <div className={classes.ModalBackground}>
                <div className={classes.ModalContent}>
                    <div className={classes.readyMain}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <p className={classes.readyHead}>
                                All Ready to use Bonuses
                            </p>
                            <p className={classes.readyRight} onClick={() => setShowAll('')}>
                                <CrossBorderSvg />
                            </p>
                        </div>
                        {dataReady.display ? <div style={{ maxHeight: '600px', overflowY: 'auto' }}><table className={classes.customTable}>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th>Referral name</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataReady.data.map((item, index) => (
                                    <tr key={index}>
                                        <td>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</td>
                                        <td>{item.type}</td>
                                        <td>{item.amount}</td>
                                        <td>{dataReady.referred}</td>
                                        <td>
                                            <span className={classes.statusBadge2}>Pending</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                            {dataReady.data.map((item) => {
                                return <div className={classes.displayBox}>
                                    <p className={classes.content}>Date</p>
                                    <p className={classes.content}>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</p>
                                    <p className={classes.content}>Type</p>
                                    <p className={classes.desc}>{item.type}</p>
                                    <p className={classes.content}>Amount</p>
                                    <p className={classes.desc}>${item.amount}</p>
                                    <p className={classes.content}>Referral name</p>
                                    <p className={classes.content}>{dataReady.referred}</p>
                                    <p className={classes.content}>Status</p>
                                    <button className={classes.statusBadge2}>Pending</button>
                                </div>
                            })}
                        </div>
                            : null}
                    </div>
                </div>
            </div> :
                showAll === 'pending' ? <div className={classes.ModalBackground}>
                    <div className={classes.ModalContent}>
                        <div className={classes.readyMain}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <p className={classes.readyHead}>
                                    All Pending Bonuses
                                </p>
                                <p className={classes.readyRight} onClick={() => setShowAll('')}>
                                    <CrossBorderSvg />
                                </p>
                            </div>
                            {pendingBonus.display ? <div style={{ maxHeight: '600px', overflowY: 'auto' }}><table className={classes.customTable}>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Referral name</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pendingBonus.data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</td>
                                            <td>{item.type}</td>
                                            <td>{item.amount}</td>
                                            <td>{pendingBonus.referred}</td>
                                            <td>
                                                <span className={classes.statusBadge2}>Pending</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                                {pendingBonus.data.map((item) => {
                                    return <div className={classes.displayBox}>
                                        <p className={classes.content}>Date</p>
                                        <p className={classes.content}>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</p>
                                        <p className={classes.content}>Type</p>
                                        <p className={classes.desc}>{item.type}</p>
                                        <p className={classes.content}>Amount</p>
                                        <p className={classes.desc}>${item.amount}</p>
                                        <p className={classes.content}>Referral name</p>
                                        <p className={classes.content}>{pendingBonus.referred}</p>
                                        <p className={classes.content}>Status</p>
                                        <button className={classes.statusBadge2}>Pending</button>
                                    </div>
                                })}
                            </div>
                                : null}
                        </div>
                    </div>
                </div> : showAll === 'used' ? <div className={classes.ModalBackground}>
                    <div className={classes.ModalContent}>
                        <div className={classes.readyMain}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <p className={classes.readyHead}>
                                    All Used Bonuses
                                </p>
                                <p className={classes.readyRight} onClick={() => setShowAll('')}>
                                    <CrossBorderSvg />
                                </p>
                            </div>
                            {usedBonus.display ? <div style={{ maxHeight: '600px', overflowY: 'auto' }}><table className={classes.customTable}>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Type</th>
                                        <th>Amount</th>
                                        <th>Referral name</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usedBonus.data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</td>
                                            <td>{item.type}</td>
                                            <td>{item.amount}</td>
                                            <td>{usedBonus.referred}</td>
                                            <td>
                                                <span className={classes.statusBadge3}>Pending</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                                {usedBonus.data.map((item) => {
                                    return <div className={classes.displayBox}>
                                        <p className={classes.content}>Date</p>
                                        <p className={classes.content}>{moment.utc(item.createdOn).format('DD/MM/YYYY')}</p>
                                        <p className={classes.content}>Type</p>
                                        <p className={classes.desc}>{item.type}</p>
                                        <p className={classes.content}>Amount</p>
                                        <p className={classes.desc}>${item.amount}</p>
                                        <p className={classes.content}>Referral name</p>
                                        <p className={classes.content}>{usedBonus.referred}</p>
                                        <p className={classes.content}>Status</p>
                                        <button className={classes.statusBadge3}>Used</button>
                                    </div>
                                })}
                            </div>
                                : null}
                        </div>
                    </div>
                </div> : null
            }

        </> : <div className={classes.Loader}><div></div><div></div><div></div><div></div></div>
    );
}

export default Referrals